import { AppApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new AppApiService(ApiClientFactory());

export function AppApiServiceFactory(): typeof service {
  return service;
}
